import { render, staticRenderFns } from "./ViewPanel.vue?vue&type=template&id=37f268f4&lang=pug&"
import script from "./ViewPanel.vue?vue&type=script&lang=js&"
export * from "./ViewPanel.vue?vue&type=script&lang=js&"
import style0 from "./ViewPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports